import { CustomError } from './errorTools'

export class RequiredFieldsMissingError extends CustomError {
  override name = 'RequiredFieldsMissingError'
}

export function assertRequiredFields<TValues, TKeys extends keyof TValues>(
  values: Pick<TValues, TKeys> & Omit<TValues, TKeys>,
  requiredKeys: Readonly<Array<TKeys>>,
): asserts values is { [P in TKeys]-?: NonNullable<TValues[P]> } & Omit<TValues, TKeys> {
  const invalidKeys = requiredKeys.filter((key) => values[key] == null)
  if (invalidKeys.length) {
    throw new RequiredFieldsMissingError(
      `Required fields are null or undefined: ${JSON.stringify(invalidKeys)}`,
    )
  }
}
